export function clearTextInfo(value, text) {
  if (value !== '' && value !== undefined) {
    if (text === '') {
      return value;
    }
    return `${text} ${value}`;
  }
  return '';
}

export function joinTextInfo(info) {
  return info.filter(e => e !== '').join(' / ');
}